// Prefill rule for a counting-method row (UOM description and quantity).
// The first row of a new product always starts as "Each" / 1; the customer can
// edit the values when the entitlement allows it. Later rows are left blank when
// editable (a second "Each / 1" would only duplicate the first), while readonly
// fields keep the default, otherwise their required validator could never be
// satisfied. Assets always get quantity 1 (readonly, forced by the API).
export function defaultCountDesc(descEditable: boolean, firstRow: boolean): string {
  return firstRow || !descEditable ? 'Each' : '';
}

export function defaultCountQty(qtyEditable: boolean, isAsset: boolean, firstRow: boolean): number | '' {
  return firstRow || !qtyEditable || isAsset ? 1 : '';
}
